import type { NavigationHookAfter, Router } from 'vue-router'
import { useErrorsStore } from '@common/stores/errors'

export const afterGuard: NavigationHookAfter = async (to, _, failure) => {
  const errorsStore = useErrorsStore()

  // we dont clear errors if we are navigating to the error page itself
  // or if there was a navigation failure
  if (!failure && to.name !== '[[...path]]+')
    errorsStore.clearErrors()
}

export function applyErrorsGuard(router: Router) {
  router.afterEach(afterGuard)
}
